export default {"src":"/_next/static/media/microsoft.b317523a.svg","height":32,"width":129};